import * as Yup from "yup";

const condicionalValidator = Yup.object().shape({
  pessoaClienteId: Yup.number().nullable().required("Cliente"),
  pessoaVendedorId: Yup.number().nullable(),
  dataVencimento: Yup.date().required("Data Vencimento"),
  informacaoAdicional: Yup.string().nullable(),
  itens: Yup.array()
    .transform((value) => (Array.isArray(value) ? value : []))
    .min(1, "Incluir ao menos 1 produto"),
  condicionalEnderecoCliente: Yup.object().nullable(),
});

export default condicionalValidator;
